import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import cookies from 'js-cookie';

import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import classNames from 'classnames';
import { LangIcon, Div } from './LanguageFlags.styled';

export default function LanguageFlags() {
  const languages = [
    {
      code: 'en',
      country_code: 'gb',
      name: 'English',
    },
    {
      code: 'ua',
      country_code: 'ua',
      name: 'Українська',
    },
  ];

  const { t } = useTranslation();

  const currentLanguageCode = cookies.get('i18next') || 'en';

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Div>
      <Tooltip title={t('language')} arrow>
        <IconButton onClick={handleClick} size="small">
          <LangIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        disableScrollLock={true}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1,
            bgcolor: '#F8F8F8',
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              width: 10,
              height: 10,
              bgcolor: '#F8F8F8',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
      >
        {languages.map(({ code, name, country_code }) => (
          <Tooltip key={code}>
            <MenuItem
              style={{
                height: '24px',
                padding: '4px',
                backgroundColor:
                  currentLanguageCode === code
                    ? 'var(--accent-background-color)'
                    : '#F8F8F8',
                border:
                  currentLanguageCode === code
                    ? '1px solid #ffffff'
                    : '#F8F8F8',
                textColor:
                  currentLanguageCode === code
                    ? 'var(--primary-background-color)'
                    : '#F8F8F8',
              }}
            >
              <IconButton
                className={classNames('dropdown-item')}
                onClick={() => {
                  i18next.changeLanguage(code);
                }}
                style={{ fontSize: '18px' }}
              >
                {name}
              </IconButton>
            </MenuItem>
          </Tooltip>
        ))}
      </Menu>
    </Div>
  );
}
